<template>
		<div class="page-title">
			<!-------------------------- 01：「潜在意識」 -------------------------->
			<div class="wrapper" v-if="resultDetailNow==1">
				<div class="text">
					<h2>- 内向性診断 -</h2>
					<h1 >
						結果詳細1/4<br>

						「潜在意識」
					</h1>											
					<div class="explain">
						<p>あなたの内向的特徴は潜在意識がどこに向くかによって、長所にも短所にもなり得る。</p>
					</div><!-- end .explain -->
				</div><!-- end .text -->
				<div class="image">
					<img src="../assets/result-detail-sacrifice-title.svg" alt="*">
				</div><!-- end .image -->
			</div><!-- end .wrapper -->
			<!-------------------------- 02：「自己投資」 -------------------------->
			<div class="wrapper" v-if="resultDetailNow==2">
				<div class="text">
					<h2>- 内向性診断 -</h2>
					<h1 >
						結果詳細2/4<br>

						「自己投資」
					</h1>											
					<div class="explain">
						<p>自身の内向性に合わせた自己投資をすることで、ローリスクハイリターンで人生を勝ち抜ける。</p>
					</div><!-- end .explain -->
				</div><!-- end .text -->
				<div class="image">
					<img src="../assets/result-detail-invest-title.svg" alt="*">
				</div><!-- end .image -->
			</div><!-- end .wrapper -->
			<!-------------------------- 03：「コミュニケーション」 -------------------------->
			<div class="wrapper" v-if="resultDetailNow==3">
				<div class="text">
					<h2>- 内向性診断 -</h2>
					<h1 >
						結果詳細3/4<br>

						「コミュニケーション」
					</h1>											
					<div class="explain">
						<p>コミュニケーションは人間生活のあらゆる場面の結果に起因する。だからこそ、あなたの内向性とコミュニケーションをうまく融合させる必要があるのだ。</p>
					</div><!-- end .explain -->
				</div><!-- end .text -->
				<div class="image">
					<img src="../assets/result-detail-communication-title.svg" alt="*">
				</div><!-- end .image -->
			</div><!-- end .wrapper -->	
			<!-------------------------- 04：「アウトプット」 -------------------------->
			<div class="wrapper" v-if="resultDetailNow==4">
				<div class="text">
					<h2>- 内向性診断 -</h2>
					<h1 >
						結果詳細4/4<br>

						「アウトプット」
					</h1>											
					<div class="explain">
						<p>内に秘める内向性とアウトプットの質は人生を大きく掛け算する最たる要素だ。</p>
					</div><!-- end .explain -->
				</div><!-- end .text -->
				<div class="image">
					<img src="../assets/result-detail-output-title.svg" alt="*">
				</div><!-- end .image -->
			</div><!-- end .wrapper -->
			<!-------------------------- 05：「最後に」 -------------------------->
			<div class="wrapper last" v-if="resultDetailNow==5">
				<div class="text">
					<h2>さらなる成功と幸福へ向けて</h2>
					<h1 >
						<span>－ 診断の最後に －</span><br>
						これからのあなたへ

					</h1>											
					<div class="explain">
						<p>あなたの人生は、自分の内に溢れる可能性をどんどん外へ開き、ますます輝きを増すばかりだ。</p>
					</div><!-- end .explain -->
				</div><!-- end .text -->
				<div class="image">
					<img src="../assets/result-detail-last-message-title.svg" alt="*">
				</div><!-- end .image -->
			</div><!-- end .wrapper -->									
		</div><!-- end .page-title -->
</template>

<script>
export default {
	name: 'ResultDetailTitle',
	props:[
		'resultDetailNow',
	],	
	components: {
	},
	
	data: function () {
		return {


		}
	},

	computed: {

	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">


</style>
